import { BaseModel, Form, EntryTypes, Entry, Resource } from '@ngx-resource-toolkit/core';
import { DateHelper } from '../../shared/helpers/date.helper';
import { environment } from '../../../environments/environment';
import { LeaResource } from '../../shared/resource/lea.resource';
import { FileModel } from './file.model';
import { CourrielReducer, CourrielEpics } from './courriel.store';
import { Validators } from '@angular/forms';

const STATUT_NON_ENVOYE = 1;
const STATUT_ENVOI_PROGRAMME = 2;
const STATUT_EN_ATTENTE_ENVOI = 3;
const STATUT_ENVOYE = 4;

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/courriel',
            methods: LeaResource.methods,
        }
    },
    store: {
        namespace: 'courriel',
        reducer: CourrielReducer,
        epics: CourrielEpics,
    }
})
@Form({
    'table': {},
    'create': {},
})
export class CourrielModel extends BaseModel {

    @Entry({
        'create': {
            hidden: true,
        }
    })
    _explicitType: any = 'Courriel';

    @Entry({
        base: {
            label: 'N°',
        },
        'table': {
            type: EntryTypes.TABLE,
            flexGrow: 1,
            colOrder: 0,
        },
        'create': {
            hidden: true,
        }
    })
	id: any;

    @Entry({
        base:  {
            validators: [Validators.required],
            validatorsMsgs: {
                'required': 'L objet est obligatoire',
            },
        },
        'table': {
            type: EntryTypes.TABLE,
            label: 'Objet',
            flexGrow: 1,
            colOrder: 1,
        },
        'create': {
            type: EntryTypes.TEXT,
            label: 'Object',
        }
    })
    objet: any;

    @Entry({
        'create': {
            type: EntryTypes.TEXT,
        }
    })
	corps: any;
	isHtml: any;
	destinataire: any; // Utilisé pour un envoi à un seul destinataire
    destinataires: any; // Array de CampagneDestinataire

    @Entry({
        'create': {
            nested: true,
            multiple: true
        }
    })
    piecesJointes: any; // Array de Fichier

    @Entry({
        base: {
            default: false,
        },
        'create': {
            type: EntryTypes.CHECKBOX,
        }
    })
    isAccuseReceptionDemande: boolean;
    @Entry({
        base: {
            default: false,
        },
        'create': {
            type: EntryTypes.CHECKBOX,
        }
    })
    isTemplate: boolean; // Indique s'il s'agit d'un template'

    @Entry({
        'table': {
            type: EntryTypes.TABLE,
            flexGrow: 1,
            colOrder: 5,
            label: 'Nb dest envoyé',
        }
    })
    nbEnvois: any; // Nombre de courriels envoyés (ou nombre de destinataires)

    @Entry({
        'table': {
            type: EntryTypes.TABLE,
            flexGrow: 1,
            colOrder: 3,
            label: 'Date envoi',
            transform: (value) => DateHelper.toDateTime(value),
        }
    })
	dateEnvoi: any; // timestamp d'envoi
    isEmetteurGenerique: any; // Indique si le courriel a été envoyé avec l'émetteut générique (sinon il a été envoyé avec l'adresse de l'émetteur)

    @Entry({
        'table': {
            type: EntryTypes.TABLE,
            flexGrow: 1,
            colOrder: 4,
            label: 'Emetteur',
        }
    })
	loginUserEmetteur: any; // Login de l'utilisateur ayant envoyé le courriel

    @Entry({
        base: {
            label: 'Statut',
            transform: (value, row) => {
                CourrielModel.getLibelleStatut(row.isTemplate, value);
            }
        },
        'table': {
            type: EntryTypes.TABLE,
            flexGrow: 1,
            colOrder: 2,
        },
        'edit': {
            type: EntryTypes.STATIC,

        }
    })
    statut: any;

    public static getLibelleStatut(isTemplate, statut): string {
        if (isTemplate) {
            return 'Modèle';
        }
        switch (statut) {
            case STATUT_NON_ENVOYE : // STATUT_NON_ENVOYE :
                return 'Non envoyé';
            case STATUT_ENVOI_PROGRAMME : // STATUT_ENVOI_PROGRAMME :
                return 'Envoi programmé';
            case STATUT_EN_ATTENTE_ENVOI : // STATUT_EN_ATTENTE_ENVOI :
                return 'En attente d\'envoi';
            case STATUT_ENVOYE : // STATUT_ENVOYE :
                return 'Envoyé';
            default :
                return '';
        }
    }

    constructor(data?) {
        super();
        if (!data) {
            data = {};
        }

        Object.assign(this, data);

        this.isAccuseReceptionDemande = !!data.isAccuseReceptionDemande || false;
        this.isTemplate = !!data.isTemplate || false;
        this.piecesJointes = (data.piecesJointes || []).map(pj => new FileModel(pj, pj.data64));
    }

    public initNew() {
        this.id = null;
        this.statut = STATUT_NON_ENVOYE;
        this.isAccuseReceptionDemande = false;
        this.isTemplate = false;
        this.piecesJointes = [];
        this.loginUserEmetteur = '';
        //this.corps = corps;
    }
    public libelleStatut() {
        return CourrielModel.getLibelleStatut(this.isTemplate, this.statut);
    }
    public estNonEnvoye(): boolean {
// tslint:disable-next-line: triple-equals
        return this.statut == STATUT_NON_ENVOYE || !(this.statut);
    }

}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/courriel/models/courriel.model.ts